import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'
import { useStores } from '@/components/StoreProvider'

/** Reopens the cookie preferences, so a choice can be changed or withdrawn at any time. */
export const CookiePreferencesLink = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const { consentStore } = useStores()

  return (
    <button type="button" onClick={() => consentStore.openPreferences()} className={cn('cursor-pointer text-sm underline underline-offset-2', className)}>
      {t('consent.cookie_preferences')}
    </button>
  )
}
